<div class="container">
  <div class="row justify-content-center align-items-center">
    <div class="col-md-6 text-center">
      <img class="buk-logo" src="/assets/logo-a.png" alt="BUK logo">
      <h3>{{ '404.title' | translate}}</h3>
      <p>{{ '404.subtitle' | translate}}</p>
    </div>
  </div>
</div>